import React from 'react';
import { ExternalLink } from 'lucide-react';

import './Honors.css';
import { theme } from '../../theme/designSystem';
import { honorsData } from '../../data/honorsData';

function Honors() {
    return (
        <section className="honors section-pad" id="honors" style={{ backgroundColor: theme.tertiary }}>
            <div className="container">
                <div className="honors--header">
                    <span className="eyebrow">Honors &amp; Distinctions</span>
                    <h2 style={{ color: theme.primary }}>
                        Recognition reserved for the <span className="gradient-text">top of the field</span>
                    </h2>
                    <p style={{ color: theme.textSecondary }}>
                        Elected memberships, federal recognition, acquired technologies, and industry judging:
                        independent signals of an extraordinary track record.
                    </p>
                </div>

                <div className="honors--grid">
                    {honorsData.map((honor) => {
                        const CardTag = honor.url ? 'a' : 'div';
                        const linkProps = honor.url
                            ? { href: honor.url, target: '_blank', rel: 'noreferrer' }
                            : {};
                        return (
                            <CardTag
                                {...linkProps}
                                key={honor.id}
                                className={`honor--card fade-in-up${honor.url ? ' honor--card-link' : ''}`}
                                style={{ backgroundColor: theme.cardBg, borderColor: theme.border }}
                            >
                                <div className="honor--icon">{honor.icon}</div>
                                <div className="honor--body">
                                    <h3 style={{ color: theme.primary }}>{honor.title}</h3>
                                    <span className="honor--org">{honor.org}</span>
                                    <p style={{ color: theme.textSecondary }}>{honor.description}</p>
                                </div>
                                {honor.url && (
                                    <span className="honor--external" aria-hidden="true">
                                        <ExternalLink size={15} />
                                    </span>
                                )}
                            </CardTag>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}

export default Honors;
